import { Button } from "@/components/ui/button";
import useAccount from "@/modules/account/hooks/useAccount";
import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";

export default function SignedInUser() {
  const { t } = useTranslation();
  const { account, onLogout } = useAccount();

  if (!account) {
    return null;
  }

  return (
    <div className="flex flex-justify-start gap-4 flex-col">
      <div>{account.email}</div>
      <div>
        <Button variant="secondary" onClick={onLogout}>
          <LogOut className="mr-2 w-4 h-4" />
          {t("user.logout")}
        </Button>
      </div>
    </div>
  );
}
